/*
  <product-gallery-dots>
  Affiche des points de position sous la galerie produit.
  Ne reimplemente pas la logique de slider : lit le compteur natif de Dawn
  (.slider-counter--current / --total), masque en CSS, et se resynchronise
  a chaque changement via MutationObserver. Fonctionne donc avec le swipe,
  le clavier, les vignettes et les changements de variante.
*/
if (!customElements.get('product-gallery-dots')) {
  class ProductGalleryDots extends HTMLElement {
    connectedCallback() {
      this.sliderComponent = this.closest('slider-component');
      this.slider = document.getElementById(this.dataset.slider);
      this.counter = this.sliderComponent ? this.sliderComponent.querySelector('.slider-counter') : null;
      this.currentEl = this.counter ? this.counter.querySelector('.slider-counter--current') : null;
      this.totalEl = this.counter ? this.counter.querySelector('.slider-counter--total') : null;

      if (!this.slider || !this.currentEl || !this.totalEl) return;

      this.list = document.createElement('ul');
      this.list.className = 'product-gallery-dots__list list-unstyled';
      this.list.setAttribute('role', 'list');
      this.appendChild(this.list);

      this.onClick = this.onClick.bind(this);
      this.list.addEventListener('click', this.onClick);

      this.observer = new MutationObserver(() => this.render());
      this.observer.observe(this.counter, { subtree: true, childList: true, characterData: true });

      this.render();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    visibleSlides() {
      return Array.from(this.slider.querySelectorAll('.product__media-item')).filter(
        (slide) => slide.offsetWidth > 0
      );
    }

    onClick(event) {
      const button = event.target.closest('button[data-index]');
      if (!button) return;

      const slides = this.visibleSlides();
      const target = slides[parseInt(button.dataset.index, 10) - 1];
      if (!target || !slides[0]) return;

      this.slider.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }

    label(index) {
      const template = this.dataset.labelTemplate || 'Image __index__';
      return template.replace('__index__', index);
    }

    render() {
      const total = parseInt(this.totalEl.textContent, 10) || 0;
      const current = parseInt(this.currentEl.textContent, 10) || 1;

      this.hidden = total < 2;
      if (this.hidden) {
        this.list.innerHTML = '';
        return;
      }

      if (this.list.children.length !== total) {
        const fragment = document.createDocumentFragment();

        for (let index = 1; index <= total; index++) {
          const item = document.createElement('li');
          const button = document.createElement('button');

          button.type = 'button';
          button.className = 'product-gallery-dots__dot';
          button.dataset.index = index;
          button.setAttribute('aria-label', this.label(index));

          item.appendChild(button);
          fragment.appendChild(item);
        }

        this.list.innerHTML = '';
        this.list.appendChild(fragment);
      }

      Array.from(this.list.querySelectorAll('button')).forEach((button, index) => {
        const isActive = index + 1 === current;
        button.classList.toggle('is-active', isActive);

        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('product-gallery-dots', ProductGalleryDots);
}

/*
  CORRECTIF TEMPORAIRE - bloc de reassurance

  Les libelles du bloc .lac-reassurance contiennent des <br> ecrits en dur
  ("Paiement<br>100%<br>securise"). Ils forcent trois lignes quelle que soit
  la largeur disponible, ce qui gonflait la bande et laissait de gros vides.
  Aucune regle CSS ne peut annuler proprement un <br> : le masquer supprime
  aussi l'espace entre les mots. On le remplace donc par une espace en JS.

  A SUPPRIMER des que les <br> auront ete retires du bloc Liquid dans
  l'editeur de theme. C'est un pansement, pas la bonne place pour ce correctif.
*/
(function () {
  function unwrapReassuranceBreaks() {
    document.querySelectorAll('.lac-title br').forEach(function (br) {
      br.replaceWith(' ');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', unwrapReassuranceBreaks);
  } else {
    unwrapReassuranceBreaks();
  }

  document.addEventListener('shopify:section:load', unwrapReassuranceBreaks);
})();
